"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildSuccessAction = exports.buildRequestAction = exports.buildErrorAction = void 0;

var buildErrorAction = function buildErrorAction(actionName) {
  return "".concat(actionName, "/error");
};

exports.buildErrorAction = buildErrorAction;

var buildRequestAction = function buildRequestAction(actionName) {
  return "".concat(actionName, "/request");
};

exports.buildRequestAction = buildRequestAction;

var buildSuccessAction = function buildSuccessAction(actionName) {
  return "".concat(actionName, "/success");
};

exports.buildSuccessAction = buildSuccessAction;